import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PaperClipIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9191 4.93232L6.50066 11.5225C4.54804 13.4751 4.54798 16.6409 6.5006 18.5935C8.45322 20.5461 11.619 20.5461 13.5717 18.5935L13.5725 18.5927L19.8299 12.35C20.2208 11.96 20.854 11.9607 21.2441 12.3517C21.6341 12.7427 21.6334 13.3758 21.2424 13.7659L14.9859 20.0077C14.9857 20.0079 14.986 20.0076 14.9859 20.0077C12.2522 22.7409 7.81991 22.7412 5.08639 20.0077C2.35433 17.2757 2.35272 12.8471 5.08153 10.1131L11.5005 3.52237C13.4532 1.56975 16.619 1.56981 18.5717 3.52243C20.5227 5.47342 20.5243 8.63558 18.5766 10.5886L12.1575 17.1793C10.9859 18.3509 9.08639 18.3509 7.91481 17.1793C6.74324 16.0077 6.74324 14.1082 7.91481 12.9366L14.5006 6.35086C14.8911 5.96034 15.5243 5.96034 15.9148 6.35086C16.3053 6.74139 16.3053 7.37455 15.9148 7.76507L9.32903 14.3509C8.9385 14.7414 8.9385 15.3745 9.32903 15.7651C9.71826 16.1543 10.3485 16.1556 10.7393 15.7689L17.1574 9.17923C18.329 8.00765 18.329 6.10822 17.1575 4.93665C15.9873 3.76652 14.0911 3.76508 12.9191 4.93232Z"
            />
        </SvgIcon>
    );
};

export default PaperClipIcon;
